import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'atm-time-interval',
  templateUrl: './time-interval.component.html',
  styleUrls: ['./time-interval.component.scss'],
})
export class TimeIntervalComponent implements OnInit {
  @Input() duration: string | null = null;
  @Output() settedDuration = new EventEmitter<{
    value: string;
    display: string;
  } | null>();
  value = new FormControl('');
  custom = false;
  form: FormGroup = this.fb.group({
    date: this.fb.group({
      Y: [],
      M: [],
      W: [],
      D: [],
    }),
    time: this.fb.group({
      H: [],
      M: [],
    }),
  });

  get dateGroup(): FormGroup {
    return this.form.get('date') as FormGroup;
  }
  get timeGroup(): FormGroup {
    return this.form.get('time') as FormGroup;
  }
  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.value.setValue(this.duration);
    if (this.duration) {
      this.setValue(this.duration);
    }
    this.form.valueChanges.subscribe((values) => {
      this.setDuration(values);
    });
    this.value.valueChanges.subscribe((val) => {
      this.custom = true;
      this.sendDuration(val || '', val || '');
    });
  }

  setValue(data: string) {
    const split = data.split(/\T+/g);
    if (data.indexOf('T') > -1) {
      const time = split[1].match(/[a-zA-Z]+|[0-9]+/g);

      time?.map((t, i) => {
        if (!isNaN(Number(t))) {
          this.timeGroup.get(time[i + 1])?.patchValue(t);
        }
      });
    }
    const date = split[0].match(/[a-zA-Z]+|[0-9]+/g);
    date?.map((d, i) => {
      if (!isNaN(Number(d))) {
        this.dateGroup.get(date[i + 1])?.patchValue(d);
      }
    });
  }

  setDuration(values: any | undefined) {
    let duration = 'P';
    let timeSetted = false;
    for (let value in values.date) {
      if (values.date[value] && values.date[value] > 0) {
        duration += values.date[value] + value;
      }
    }
    for (let value in values.time) {
      if (values.time[value] && values.time[value] > 0) {
        if (!timeSetted) {
          duration += 'T';
          timeSetted = true;
        }
        duration += values.time[value] + value;
      }
    }
    this.value.setValue(duration);

    this.custom = false;
    this.sendDuration(duration, this.setDisplayDuration(duration));
  }

  sendDuration(value: string, display: string): void {
    this.settedDuration.emit({
      value,
      display,
    });
  }

  setDisplayDuration(data: string | undefined): string {
    if (data) {
      const split = data.split(/\T+/g);
      const date = this.setDateDuration(split[0].replace('P', ''));
      const time = split[1]
        ? `${split[0].length > 1 ? ' - ' : ''}${this.setTimeDuration(split[1])}`
        : '';
      return date + time;
    }
    return '';
  }

  private setDateDuration(date: string): string {
    date = date.replace('Y', ' year');
    date = date.replace('M', ' month');
    date = date.replace('D', ' day');
    date = date.replace('W', ' week');
    const split = date.match(/[a-zA-Z]+|[0-9]+/g);
    let dateString = '';
    split?.map((value, i) => {
      if (!isNaN(Number(value))) {
        dateString += `${value} ${split[i + 1]}${Number(value) > 1 ? 's' : ''}${
          split[i + 2] ? ' ' : ''
        }`;
      }
    });
    return dateString;
  }

  private setTimeDuration(time: string): string {
    time = time.replace('H', ' h');
    time = time.replace('M', ' min');
    time = time.replace('S', ' s');
    const split = time.match(/[a-zA-Z]+|[0-9]+/g);
    let timeString = '';
    split?.map((value, i) => {
      if (!isNaN(Number(value))) {
        timeString += `${value} ${split[i + 1]}.${split[i + 2] ? ' ' : ''}`;
      }
    });
    return timeString;
  }
}
